import { render, staticRenderFns } from "./communityGuidelines.vue?vue&type=template&id=ec4b6dd0&"
import script from "./communityGuidelines.vue?vue&type=script&lang=js&"
export * from "./communityGuidelines.vue?vue&type=script&lang=js&"
import style0 from "./communityGuidelines.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports